import { render, staticRenderFns } from "./modal-with-cancel.mpx?vue&type=template&id=56ea7d1e&isComponent&outputPath=components%2Fmodal-with-cancel273c406c%2Findex"
import script from "./modal-with-cancel.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-cancel273c406c%2Findex"
export * from "./modal-with-cancel.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fmodal-with-cancel273c406c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports